// @flow
import type {Circle, LinkedRole, OriginalRole} from './types'

const destroySummary = ({originalRole}: LinkedRole): ?string => {
  if (!originalRole)
    return null

  if (!originalRole.circle)
    return null

  return I18n.t('proposals.link_role.will_remove', {
    role: originalRole.localizedName,
    circle: originalRole.circle.localizedName,
  })
}

function createSummary(originalRole: ?OriginalRole, circle: Circle): string {
  if (!originalRole)
    return I18n.t('proposals.link_role.will_invite')

  return I18n.t('proposals.link_role.invited_to_link', {
    role: originalRole.localizedName,
    circle: circle.localizedName,
  })
}

export {
  createSummary,
  destroySummary,
}
